import React, { useEffect } from "react";
import api from "../../services/api";

const packageVersion = require("../../../package.json").version;

const VersionControl = () => {
  useEffect(() => {
    const stored = window.localStorage.getItem("version") || "0.0.0";
    const alreadyReloaded = sessionStorage.getItem("didAutoUpdateReload");

    // Se a versão mudou, registramos e garantimos um reload único
    if (stored !== packageVersion) {
      try {
        window.localStorage.setItem("version", packageVersion);
      } catch {}

      // Telemetria silenciosa (não bloqueante)
      try {
        api.post("/version", { version: packageVersion }).catch(() => {});
      } catch {}

      // Modo B: recarregar automaticamente UMA única vez para garantir sync total
      if (!alreadyReloaded) {
        try {
          sessionStorage.setItem("didAutoUpdateReload", "1");
        } catch {}

        // Opcional: pedir update do SW registrado (não bloqueia)
        try {
          if ("serviceWorker" in navigator) {
            navigator.serviceWorker.ready
              .then((reg) => reg && reg.update && reg.update())
              .catch(() => {});
          }
        } catch {}

        // Recarrega a página para aplicar a nova UI
        window.location.reload();
      }
    }
  }, []);

  // Com atualização automática, nada é renderizado
  return null;
};

export default VersionControl;
